import React, { useState } from "react";
import styled from "styled-components";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import { selectCars } from "../features/car/carSlice";
import { useSelector } from "react-redux";

function Header() {
  const [showSidebar, setShowSidebar] = useState(false);
  const cars = useSelector(selectCars);
  console.log(cars);

  return (
    <div>
      <Container>
        <a href="#">
          <img src="./assets/logo.svg" alt="tesla's logo" />
        </a>
        <Menu>
          {cars?.map((car, index) => (
            <a key={index} href="#">
              {car}
            </a>
          ))}
        </Menu>

        <RightMenu>
          <a href="#">Shop</a>
          <a href="#">Tesla Account</a>
          <CustomMenu onClick={() => setShowSidebar(true)} />
        </RightMenu>

        <BurgerNav show={showSidebar}>
          <CloseWrapper>
            <CustomClose onClick={() => setShowSidebar(false)} />
          </CloseWrapper>
          {cars?.map((car, index) => (
            <li key={index}>
              <a href="">{car}</a>
            </li>
          ))}
          <li>
            <a href="">Existing Inventory</a>
          </li>
          <li>
            <a href="">Used inventory</a>
          </li>
          <li>
            <a href="">Trade-in</a>
          </li>
          <li>
            <a href="">Cybertruck</a>
          </li>
          <li>
            <a href="">Roadaste</a>
          </li>
          <li>
            <a href="">Semi</a>
          </li>
          <li>
            <a href="">Charging</a>
          </li>
          <li>
            <a href="">Power</a>
          </li>
          <li>
            <a href="">Community</a>
          </li>
          <li>
            <a href="">Utilities</a>
          </li>
        </BurgerNav>
      </Container>
    </div>
  );
}

export default Header;

const Container = styled.div`
  min-height: 60px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  a {
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 10px;
    flex-wrap: nowrap;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 10px;
    margin-right: 10px;
  }
`;

const CustomMenu = styled(MenuIcon)`
  display: flex;
  cursor: pointer;
`;

const BurgerNav = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: white;
  width: 300px;
  z-index: 100000;
  list-style: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
  transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.4s;

  li {
    padding: 15px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);

    a {
      font-weight: 600;
    }
  }
`;

const CloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CustomClose = styled(CloseIcon)`
  cursor: pointer;
`;
